import { Component, Input } from '@angular/core';
import { environment } from '@env/environment';
import { TrackingService } from '@core/services';

@Component({
    selector: 'gh-snippet-mobile',
    templateUrl: 'snippet-mobile.component.html',
    standalone: false
})

export class SnippetMobileComponent {
  @Input() article: any;
  @Input() size = 'h2';

  constructor(private trackingService: TrackingService) { }

  hashClick(term: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'submit_search',
      events: {
        feature: 'blog',
        environment: environment.env,
        click_text: term,
        location
      }
    });
  }
}
